export default [
  // {
  //   path: '/fo/library',
  //   name: '도서관 레이아웃',
  //   component: () => import('@/page/library/LibraryLayout.vue'),
  //   children: [
  //
  //   ]
  // },
  {
    path: '/fo/library',
    name: '도서관',
    component: () => import('@/page/library/LibraryMain.vue')
  },
  {
    path: '/fo/library/suggest/:id',
    name: '도서관 추천',
    component: () => import('@/page/library/LibrarySuggest.vue')
  },
  {
    path: '/fo/library/details',
    name: '도서관 상세',
    component: () => import('@/page/library/LibraryDetails.vue')
  },
  {
    path: '/fo/library/interest',
    name: '관심 콘텐츠',
    component: () => import('@/page/library/LibraryInterestContents.vue')
  },
  {
    path: '/fo/library/search',
    name: 'LibrarySearch',
    component: () => import('@/page/library/LibrarySearch.vue')
  },
  {
    path: '/fo/library/search/details',
    name: '도서관 검색 상세',
    component: () => import('@/page/library/LibrarySearchDetails.vue')
  },
  {
    path: '/fo/library/searchResults',
    name: '도서관 검색 결과',
    component: () => import('@/page/library/LibrarySearchResults.vue')
  },
  {
    path: '/fo/library/:area',
    component: () => import('@/page/library/LibraryView')
  }
]
